module.exports = __webpack_public_path__ + "img/login_bg.ce95635d.png";